import React, { Component } from 'react';
import clsx from 'clsx';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { CssBaseline, Container, Typography, Box, Chip, Button, Tabs, Tab, Badge, Checkbox, Tooltip, IconButton, LinearProgress, Skeleton, Menu, MenuItem, CircularProgress, TablePagination } from '@mui/material';
import { withStyles } from '@mui/styles';
import { Styles } from '../../styles/material-styles';
import HeaderMenu from '../../components/header-menu';
import Footer from '../../components/footer';
import CustomizedSnackbars from '../../components/material-snackbars';
import { injectIntl } from 'react-intl';
import * as componentActions from '../../redux/actions/header-menu';
import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined';
import AddIcon from '@mui/icons-material/Add';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import ScheduleOutlinedIcon from '@mui/icons-material/ScheduleOutlined';
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import PauseCircleOutlineIcon from '@mui/icons-material/PauseCircleOutline';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import StopCircleOutlinedIcon from '@mui/icons-material/StopCircleOutlined';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import RefreshIcon from '@mui/icons-material/Refresh';
import ReplayIcon from '@mui/icons-material/Replay';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import ListAltOutlinedIcon from '@mui/icons-material/ListAltOutlined';
import BoltIcon from '@mui/icons-material/Bolt';
import ScienceOutlinedIcon from '@mui/icons-material/ScienceOutlined';
import UndoOutlinedIcon from '@mui/icons-material/UndoOutlined';
import Api from '../../services/api';
import MarketingService, { normalizeBroadcastListItem } from '../../services/marketing.service';
import moment from 'moment';
import { Overlay } from '../../styles/global';
import DialogConfirmation from '../../components/dialog-confirmation-not-button';

const fmtDate = (s) => (s ? moment(s).format('DD/MM/YYYY HH:mm') : '—');

// Status do ciclo de vida: draft | scheduled | active | completed (espelha as abas do documento).

const STATUS_META = {
  draft:     { color: '#8a8a8a', bg: '#f1f1f1', badge: '#e53935', tabKey: 'marketing.tab.drafts' },
  scheduled: { color: '#277afe', bg: '#e8f1ff', badge: '#fb8c00', tabKey: 'marketing.tab.scheduled' },
  active:    { color: '#5b9b1e', bg: '#eef7e3', badge: '#277afe', tabKey: 'marketing.tab.active' },
  paused:    { color: '#b9770e', bg: '#fff7e8', badge: '#f59e0b', tabKey: 'marketing.tab.paused' },
  completed: { color: '#4a4a4a', bg: '#ececec', badge: '#5b9b1e', tabKey: 'marketing.tab.completed' },
};

// Cor do chip por categoria Meta do template (destaque visual).
const CATEGORY_META = {
  Marketing:      { color: '#8e44ad', bg: '#f4ecfa', border: '#e0c8f0' },
  Utility:        { color: '#2d7a9e', bg: '#e8f4fa', border: '#bfe3f0' },
  Authentication: { color: '#b9770e', bg: '#fff7e8', border: '#ffe0a0' },
};

const TAB_ORDER = ['draft', 'scheduled', 'active', 'paused', 'completed'];

class MarketingBroadcastList extends Component {
  constructor(props) {
    super(props);
    // Restaura a aba de origem quando a página retorna via "Voltar" (?tab=<status>).
    const tabParam = new URLSearchParams(props.location ? props.location.search : '').get('tab');
    const initialTab = Math.max(0, TAB_ORDER.indexOf(tabParam));
    this.state = {
      loading: true,
      broadcasts: [],   // página atual da aba corrente (server-side)
      counts: {},       // { status: total } — badges das abas
      page: 0,          // 0-based
      rowsPerPage: 10,
      total: 0,         // total da aba corrente
      tab: initialTab,
      selected: [],
      rowMenuAnchor: null,
      rowMenuItem: null,
      actionLoading: false,
      confirm: null, // { msg, onConfirm }
      notification: { open: false, variant: 'success', message: '' },
    };
  }

  notify = (message, variant = 'success') => this.setState({ notification: { open: true, variant, message } });

  // Permissões pelo PERFIL REAL do usuário logado (não por seletor). roletype: 0=GlobalAdmin,1=Admin,
  // 2=Técnico,4=Coordenador. Quem PUBLICA (programa/ativa/executa) = admin/global/coordenador.
  // Técnico monta o rascunho e trava nele; exclui apenas os próprios rascunhos.
  get userRoles() {
    const u = this.props.userSession;
    return (u && u.user && Array.isArray(u.user.userrole)) ? u.user.userrole : [];
  }
  canPublish = () => this.userRoles.some(ur => ur && ur.role && [0, 1, 4].includes(Number(ur.role.roletype)));
  get currentUserName() { return this.props.userSession?.user?.name; }
  canDeleteRow = (item) => this.canPublish() || (item && item.status === 'draft' && item.creator === this.currentUserName);

  componentDidMount() {
    this.loadBroadcasts();
    this.loadCounts();
  }

  // Carrega a PÁGINA da aba corrente (server-side). Clampa a página se ela ficar vazia (ex.: após excluir o último item).
  loadBroadcasts = () => {
    this.setState({ loading: true, selected: [] });
    MarketingService.listBroadcasts(this.currentStatus(), this.state.page + 1, this.state.rowsPerPage)
      .then(result => {
        const d = (result.data && result.data.success && result.data.data) ? result.data.data : {};
        const items = Array.isArray(d.items) ? d.items.map(normalizeBroadcastListItem) : [];
        const total = d.total || 0;
        if (items.length === 0 && total > 0 && this.state.page > 0) {
          this.setState({ page: 0 }, this.loadBroadcasts);   // página fora do range → volta pra 1ª
          return;
        }
        this.setState({ broadcasts: items, total, loading: false });
      })
      .catch(err => { this.setState({ loading: false }); Api.kickoff(err); });
  };

  // Contagens por status pros badges das abas (1 request).
  loadCounts = () => {
    MarketingService.getBroadcastCounts()
      .then(result => {
        const arr = (result.data && result.data.success && Array.isArray(result.data.data)) ? result.data.data : [];
        const counts = {};
        arr.forEach(c => { counts[c.status] = c.count; });
        this.setState({ counts });
      })
      .catch(() => { /* badge fica 0, não quebra a tela */ });
  };

  refreshAll = () => { this.loadBroadcasts(); this.loadCounts(); };

  get lang() {
    return (window.location.pathname.split('/')[1]) || 'pt';
  }

  handleTabChange = (_e, tab) => this.setState({ tab, selected: [], page: 0 }, this.loadBroadcasts);

  changePage = (p) => this.setState({ page: p }, this.loadBroadcasts);
  changeRowsPerPage = (n) => this.setState({ rowsPerPage: n, page: 0 }, this.loadBroadcasts);

  currentStatus = () => TAB_ORDER[this.state.tab];

  rowsForTab = () => this.state.broadcasts;   // já é a página da aba corrente

  countByStatus = (status) => this.state.counts[status] || 0;

  toggleSelectAll = (rows) => {
    const allIds = rows.map(r => r.id);
    const allSelected = allIds.length > 0 && allIds.every(id => this.state.selected.includes(id));
    this.setState({ selected: allSelected ? [] : allIds });
  };

  toggleSelect = (id) => {
    this.setState(prev => ({
      selected: prev.selected.includes(id) ? prev.selected.filter(x => x !== id) : [...prev.selected, id]
    }));
  };

  openRowMenu = (e, item) => this.setState({ rowMenuAnchor: e.currentTarget, rowMenuItem: item });
  closeRowMenu = () => this.setState({ rowMenuAnchor: null, rowMenuItem: null });

  // Propaga a aba atual (?tab=<status>) pra que o "Voltar" das telas filhas retorne pra ela.
  get tabQs() { return `?tab=${this.currentStatus()}`; }
  goToNew = () => this.props.history.push(`/${this.lang}/marketing/new${this.tabQs}`);
  goToLists = () => this.props.history.push(`/${this.lang}/marketing/lists${this.tabQs}`);
  goToReport = (id) => this.props.history.push(`/${this.lang}/marketing/report/${id}${this.tabQs}`);
  goToEdit = (id) => this.props.history.push(`/${this.lang}/marketing/edit/${id}${this.tabQs}`);

  // Clique no nome: Concluída abre o relatório; demais abrem a edição (wizard pré-preenchido).
  openRow = (row) => row.status === 'completed' ? this.goToReport(row.id) : this.goToEdit(row.id);

  handleRowAction = (actionId) => {
    const { intl } = this.props;
    const item = this.state.rowMenuItem;
    this.closeRowMenu();
    if (!item) return;
    if (actionId === 'report') { this.goToReport(item.id); return; }
    if (actionId === 'test') { this.goToEdit(item.id); return; }   // testar exige número → wizard
    if (actionId === 'downloadCsv') { this.downloadContacts(item); return; }

    // Excluir e duplicar pedem confirmação no modal padrão.
    if (actionId === 'delete') { this.setState({ confirm: { msg: intl.formatMessage({ id: 'marketing.delete.confirm' }), onConfirm: () => this.runRowOp('delete', item) } }); return; }
    if (actionId === 'duplicate') { this.setState({ confirm: { msg: intl.formatMessage({ id: 'marketing.duplicate.confirm' }), onConfirm: () => this.runRowOp('duplicate', item) } }); return; }
    if (actionId === 'rerun') { this.setState({ confirm: { msg: intl.formatMessage({ id: 'marketing.rerun.confirm' }), onConfirm: () => this.runRowOp('rerun', item) } }); return; }

    this.runRowOp(actionId, item);
  };

  runConfirm = () => { const c = this.state.confirm; this.setState({ confirm: null }); if (c && c.onConfirm) c.onConfirm(); };

  // Baixar o retrato dos contatos da transmissão (contatos da lista-alvo) em .CSV.
  downloadContacts = async (item) => {
    const { intl } = this.props;
    this.setState({ actionLoading: true });
    try {
      const result = await MarketingService.exportBroadcastContacts(item.id);
      const blob = new Blob([result.data], { type: 'text/csv;charset=utf-8;' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url; a.download = `marketing-transmissao-${item.id}-contatos.csv`;
      document.body.appendChild(a); a.click(); a.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      Api.kickoff(err);
      this.notify(intl.formatMessage({ id: 'marketing.toast.error' }), 'error');
    } finally {
      this.setState({ actionLoading: false });
    }
  };

  runRowOp = async (actionId, item) => {
    const { intl } = this.props;

    // "Executar novamente" (concluídas): duplica a transmissão e ativa a cópia — preserva o histórico da original.
    if (actionId === 'rerun') {
      this.setState({ actionLoading: true });
      try {
        const dup = await MarketingService.duplicateBroadcast(item.id);
        const newId = dup.data && dup.data.success && dup.data.data && dup.data.data.id;
        if (!newId) {
          const e = dup.data && dup.data.errors && dup.data.errors[0];
          this.notify(e || intl.formatMessage({ id: 'marketing.toast.error' }), 'error');
          return;
        }
        const act = await MarketingService.activateBroadcast(newId);
        if (act.data && act.data.success) {
          this.notify(intl.formatMessage({ id: 'marketing.toast.rerun' }));
          this.refreshAll();
        } else {
          const e = act.data && act.data.errors && act.data.errors[0];
          this.notify(e || intl.formatMessage({ id: 'marketing.toast.error' }), 'error');
        }
      } catch (err) {
        Api.kickoff(err);
        this.notify(intl.formatMessage({ id: 'marketing.toast.error' }), 'error');
      } finally {
        this.setState({ actionLoading: false });
      }
      return;
    }

    const opMap = {
      execute: () => MarketingService.activateBroadcast(item.id),
      toDraft: () => MarketingService.revertToDraft(item.id),
      pause: () => MarketingService.pauseBroadcast(item.id),
      resume: () => MarketingService.resumeBroadcast(item.id),
      stop: () => MarketingService.finishBroadcast(item.id),
      duplicate: () => MarketingService.duplicateBroadcast(item.id),
      delete: () => MarketingService.deleteBroadcast(item.id),
    };
    const toastMap = {
      execute: 'marketing.toast.execute', delete: 'marketing.toast.deleted', toDraft: 'marketing.toast.toDraft',
      pause: 'marketing.toast.paused', resume: 'marketing.toast.resumed', stop: 'marketing.toast.stopped',
      duplicate: 'marketing.toast.duplicated',
    };
    const op = opMap[actionId];
    if (!op) return;

    this.setState({ actionLoading: true });
    try {
      const result = await op();
      if (result.data && result.data.success) {
        this.notify(intl.formatMessage({ id: toastMap[actionId] }));
        this.refreshAll();
      } else {
        const e = result.data && result.data.errors && result.data.errors[0];
        this.notify(e || intl.formatMessage({ id: 'marketing.toast.error' }), 'error');
      }
    } catch (err) {
      Api.kickoff(err);
      this.notify(intl.formatMessage({ id: 'marketing.toast.error' }), 'error');
    } finally {
      this.setState({ actionLoading: false });
    }
  };

  renderStatusChip(status) {
    const { intl } = this.props;
    const meta = STATUS_META[status];
    return (
      <Chip
        size="small"
        label={intl.formatMessage({ id: meta.tabKey })}
        sx={{ borderRadius: '6px', backgroundColor: meta.bg, color: meta.color, fontWeight: 600, fontSize: 12 }}
      />
    );
  }

  // Resumo legível da recorrência (ex.: "Todo dia às 09:00", "Toda semana (seg, qua) às 09:00").
  recurrenceText = (rec) => {
    const { intl } = this.props;
    if (!rec) return '—';
    const time = rec.time || '';
    const n = rec.interval > 1 ? rec.interval : null;
    if (rec.freq === 'daily')
      return n ? intl.formatMessage({ id: 'marketing.sched.dailyN' }, { n, time }) : intl.formatMessage({ id: 'marketing.sched.daily' }, { time });
    if (rec.freq === 'weekly') {
      const days = (rec.weekdays || []).map(d => moment.weekdaysShort(d)).join(', ') || '—';
      return n ? intl.formatMessage({ id: 'marketing.sched.weeklyN' }, { n, days, time }) : intl.formatMessage({ id: 'marketing.sched.weekly' }, { days, time });
    }
    if (rec.monthlyMode === 'dayOfMonth')
      return intl.formatMessage({ id: 'marketing.sched.monthlyDay' }, { day: rec.dayOfMonth, time });
    return intl.formatMessage({ id: 'marketing.sched.monthlyNth' }, { time });
  };

  // Célula de agendamento: mostra a realidade do cadastro (recorrência + próxima execução, ou data única).
  renderSchedule = (row) => {
    const { intl } = this.props;
    if (row.scheduleMode === 'recurring') {
      return (
        <Box>
          <Typography sx={{ fontSize: 12.5, color: '#333', fontWeight: 600 }}>{this.recurrenceText(row.recurrence)}</Typography>
          {row.scheduledAt && (
            <Typography sx={{ fontSize: 11, color: '#888' }}>{intl.formatMessage({ id: 'marketing.sched.next' }, { when: fmtDate(row.scheduledAt) })}</Typography>
          )}
        </Box>
      );
    }
    if (row.scheduleMode === 'once') {
      return (
        <Typography sx={{ fontSize: 12.5, color: row.scheduledAt ? '#333' : '#bbb' }}>
          {row.scheduledAt ? intl.formatMessage({ id: 'marketing.sched.once' }, { when: fmtDate(row.scheduledAt) }) : '—'}
        </Typography>
      );
    }
    return <Typography sx={{ fontSize: 12.5, color: row.scheduledAt ? '#333' : '#bbb' }}>{row.scheduledAt ? fmtDate(row.scheduledAt) : '—'}</Typography>;
  };

  // Chip do template com destaque da categoria Meta (cor própria + selo).
  renderTemplateChip(row) {
    const cat = CATEGORY_META[row.category] || CATEGORY_META.Utility;
    return (
      <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.6, maxWidth: 230 }}>
        <Chip size="small" label={row.template || '—'}
          sx={{ borderRadius: '6px', fontSize: 11, fontWeight: 600, backgroundColor: cat.bg, color: cat.color, border: `1px solid ${cat.border}`, maxWidth: 160, '& .MuiChip-label': { overflow: 'hidden', textOverflow: 'ellipsis' } }} />
        {row.category && (
          <Box sx={{ px: 0.6, py: '1px', borderRadius: '4px', backgroundColor: cat.color, color: '#fff', fontSize: 9, fontWeight: 700, letterSpacing: 0.3 }}>
            {row.category.slice(0, 4).toUpperCase()}
          </Box>
        )}
      </Box>
    );
  }

  renderProgress(row) {
    if (row.status === 'draft' || row.status === 'scheduled') return <Typography sx={{ fontSize: 12, color: '#bbb' }}>—</Typography>;
    const pct = row.total > 0 ? Math.round((row.sent / row.total) * 100) : 0;
    return (
      <Box sx={{ minWidth: 120 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
          <Typography sx={{ fontSize: 11, color: '#666' }}>{row.sent.toLocaleString('pt-BR')}/{row.total.toLocaleString('pt-BR')}</Typography>
          <Typography sx={{ fontSize: 11, color: '#666', fontWeight: 600 }}>{pct}%</Typography>
        </Box>
        <LinearProgress variant="determinate" value={pct} sx={{ height: 6, borderRadius: 3, backgroundColor: '#eee', '& .MuiLinearProgress-bar': { backgroundColor: row.status === 'completed' ? '#5b9b1e' : '#8BC34A' } }} />
      </Box>
    );
  }

  // Ações por aba, filtradas pelo PERFIL real. Editar = clique no nome; Programar = wizard.
  // Publicar (Executar/Voltar p/ rascunho) e pausar/encerrar = só quem pode publicar (admin/coord).
  // Técnico: rascunho → Teste/Duplicar (+Excluir só dos próprios). Ativas/Programadas: só Relatório/visual.
  rowActionsFor(status, item) {
    const { intl } = this.props;
    const A = (id, icon, labelId) => ({ id, icon, label: intl.formatMessage({ id: labelId }) });
    const pub = this.canPublish();
    const del = A('delete', <DeleteOutlineIcon fontSize="small" />, 'delete');
    const dup = A('duplicate', <ContentCopyOutlinedIcon fontSize="small" />, 'marketing.action.duplicate');
    const test = A('test', <ScienceOutlinedIcon fontSize="small" />, 'marketing.action.test');
    const csv = A('downloadCsv', <FileDownloadOutlinedIcon fontSize="small" />, 'marketing.action.downloadCsv');
    const toDraft = A('toDraft', <UndoOutlinedIcon fontSize="small" />, 'marketing.action.toDraft');
    const rerun = A('rerun', <ReplayIcon fontSize="small" />, 'marketing.action.rerun');

    let actions = [];
    switch (status) {
      case 'draft':
        actions = pub ? [A('execute', <BoltIcon fontSize="small" />, 'marketing.action.execute'), test, dup] : [test, dup];
        if (this.canDeleteRow(item)) actions.push(del);
        break;
      case 'scheduled':
        // "Voltar para rascunho" primeiro.
        actions = pub ? [toDraft, A('execute', <BoltIcon fontSize="small" />, 'marketing.action.execute'), del] : [dup];
        break;
      case 'active':
        actions = pub ? [
          A('pause', <PauseCircleOutlineIcon fontSize="small" />, 'marketing.action.pause'),
          A('resume', <PlayCircleOutlineIcon fontSize="small" />, 'marketing.action.resume'),
          A('stop', <StopCircleOutlinedIcon fontSize="small" />, 'marketing.action.stop'),
        ] : [];
        break;
      case 'paused':
        // Pausada: Retomar (→active) ou Encerrar (→completed).
        actions = pub ? [
          A('resume', <PlayCircleOutlineIcon fontSize="small" />, 'marketing.action.resume'),
          A('stop', <StopCircleOutlinedIcon fontSize="small" />, 'marketing.action.stop'),
        ] : [];
        break;
      case 'completed':
        // "Executar novamente" primeiro.
        actions = pub ? [rerun, A('report', <AssessmentOutlinedIcon fontSize="small" />, 'marketing.action.report')]
                      : [A('report', <AssessmentOutlinedIcon fontSize="small" />, 'marketing.action.report')];
        actions.push(dup);
        break;
      default: actions = [];
    }
    // "Ver relatório" também em scheduled/active/paused que JÁ executaram (last_run_id) — acessa o log das execuções.
    // 'completed' já tem o report na própria lista; 'draft' nunca executou.
    if (item && item.lastRunId && status !== 'completed' && status !== 'draft') {
      actions.push(A('report', <AssessmentOutlinedIcon fontSize="small" />, 'marketing.action.report'));
    }
    actions.push(csv);   // "Baixar .CSV" disponível em qualquer status (retrato dos contatos da transmissão)
    return actions;
  }

  // Barra de seleção — o checkbox serve só pra EXCLUSÃO em massa (confirmado pelo usuário).
  bulkDelete = () => {
    const ids = this.state.selected;
    if (!ids.length) return;
    this.setState({ confirm: { msg: this.props.intl.formatMessage({ id: 'marketing.bulk.delete.confirm' }, { n: ids.length }), onConfirm: this.doBulkDelete } });
  };

  doBulkDelete = async () => {
    const ids = this.state.selected;
    if (!ids.length) return;
    this.setState({ actionLoading: true });
    try {
      const result = await MarketingService.bulkDeleteBroadcasts(ids);
      if (result.data && result.data.success) {
        this.notify(this.props.intl.formatMessage({ id: 'marketing.bulk.deleted' }, { n: ids.length }));
        this.setState({ selected: [] });
        this.refreshAll();
      } else {
        const e = result.data && result.data.errors && result.data.errors[0];
        this.notify(e || this.props.intl.formatMessage({ id: 'marketing.toast.error' }), 'error');
      }
    } catch (err) {
      Api.kickoff(err);
      this.notify(this.props.intl.formatMessage({ id: 'marketing.toast.error' }), 'error');
    } finally {
      this.setState({ actionLoading: false });
    }
  };

  renderBulkBar() {
    const { intl } = this.props;
    const n = this.state.selected.length;
    if (n === 0) return null;
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5, p: 1, px: 1.5, borderRadius: '10px', backgroundColor: '#fdecea', border: '1px solid #f5c6cb' }}>
        <Typography sx={{ fontSize: 13, fontWeight: 600, color: '#c0392b' }}>
          {n} {intl.formatMessage({ id: 'marketing.bulk.selected' })}
        </Typography>
        <Box sx={{ flex: 1 }} />
        {this.canPublish()
          ? <Button size="small" startIcon={<DeleteOutlineIcon />} onClick={this.bulkDelete} sx={{ textTransform: 'none', color: '#c0392b' }}>
              {intl.formatMessage({ id: 'marketing.bulk.delete' })}
            </Button>
          : <Typography sx={{ fontSize: 12, color: '#999' }}>{intl.formatMessage({ id: 'marketing.bulk.adminOnly' })}</Typography>}
        <Button size="small" onClick={() => this.setState({ selected: [] })} sx={{ textTransform: 'none', color: '#888' }}>{intl.formatMessage({ id: 'cancel' })}</Button>
      </Box>
    );
  }

  renderEmpty() {
    const { intl } = this.props;
    return (
      <Box sx={{ textAlign: 'center', py: 8 }}>
        <Box sx={{ width: 72, height: 72, borderRadius: '50%', backgroundColor: '#f5f5f5', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', mb: 2 }}>
          <CampaignOutlinedIcon sx={{ fontSize: 36, color: '#bdbdbd' }} />
        </Box>
        <Typography sx={{ fontSize: 18, fontWeight: 600, color: '#555', mb: 0.5 }}>
          {intl.formatMessage({ id: 'marketing.empty.title' })}
        </Typography>
        <Typography sx={{ fontSize: 14, color: '#888', mb: 2 }}>
          {intl.formatMessage({ id: `marketing.empty.${this.currentStatus()}` })}
        </Typography>
        <Button variant="contained" startIcon={<AddIcon />} onClick={this.goToNew}
          sx={{ textTransform: 'none', backgroundColor: '#8BC34A', '&:hover': { backgroundColor: '#7cb342' } }}>
          {intl.formatMessage({ id: 'marketing.new.broadcast' })}
        </Button>
      </Box>
    );
  }

  renderTable(rows) {
    const { intl } = this.props;
    const { selected } = this.state;
    const allSelected = rows.length > 0 && rows.every(r => selected.includes(r.id));
    const someSelected = rows.some(r => selected.includes(r.id)) && !allSelected;
    const th = { textAlign: 'left', padding: '10px 12px', fontSize: 12, color: '#888', fontWeight: 600, whiteSpace: 'nowrap' };
    const td = { padding: '12px', fontSize: 13, color: '#333', borderTop: '1px solid #f0f0f0', verticalAlign: 'middle' };

    return (
      <Box sx={{ border: '1px solid #e0e0e0', borderRadius: '12px', overflow: 'hidden', backgroundColor: '#fff' }}>
        <Box sx={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: 900 }}>
            <thead>
              <tr style={{ backgroundColor: '#fafafa' }}>
                <th style={{ ...th, width: 44 }}>
                  <Checkbox size="small" checked={allSelected} indeterminate={someSelected} onChange={() => this.toggleSelectAll(rows)} />
                </th>
                <th style={{ ...th, width: 60 }}>{intl.formatMessage({ id: 'marketing.col.id' })}</th>
                <th style={th}>{intl.formatMessage({ id: 'marketing.col.name' })}</th>
                <th style={th}>{intl.formatMessage({ id: 'marketing.col.template' })}</th>
                <th style={th}>{intl.formatMessage({ id: 'marketing.col.sender' })}</th>
                <th style={th}>{intl.formatMessage({ id: 'marketing.col.list' })}</th>
                <th style={th}>{intl.formatMessage({ id: 'marketing.col.creator' })}</th>
                <th style={th}>{intl.formatMessage({ id: 'marketing.col.created' })}</th>
                <th style={th}>{intl.formatMessage({ id: 'marketing.col.scheduled' })}</th>
                <th style={th}>{intl.formatMessage({ id: 'marketing.col.status' })}</th>
                <th style={th}>{intl.formatMessage({ id: 'marketing.col.progress' })}</th>
                <th style={{ ...th, width: 56, textAlign: 'right' }}></th>
              </tr>
            </thead>
            <tbody>
              {rows.map(row => (
                <tr key={row.id} style={{ backgroundColor: selected.includes(row.id) ? '#f6fbef' : '#fff' }}>
                  <td style={td}><Checkbox size="small" checked={selected.includes(row.id)} onChange={() => this.toggleSelect(row.id)} /></td>
                  <td style={{ ...td, color: '#999', fontWeight: 600, whiteSpace: 'nowrap' }}>#{row.id}</td>
                  <td style={td}>
                    <Typography sx={{ fontSize: 13, fontWeight: 600, color: '#277afe', cursor: 'pointer' }} onClick={() => this.openRow(row)}>{row.name}</Typography>
                  </td>
                  <td style={td}>{this.renderTemplateChip(row)}</td>
                  <td style={{ ...td, whiteSpace: 'nowrap' }}>{row.sender}</td>
                  <td style={{ ...td, whiteSpace: 'nowrap' }}>{row.list}</td>
                  <td style={{ ...td, whiteSpace: 'nowrap' }}>{row.creator}</td>
                  <td style={{ ...td, whiteSpace: 'nowrap' }}>{fmtDate(row.createdAt)}</td>
                  <td style={{ ...td, whiteSpace: 'nowrap' }}>{this.renderSchedule(row)}</td>
                  <td style={td}>{this.renderStatusChip(row.status)}</td>
                  <td style={td}>{this.renderProgress(row)}</td>
                  <td style={{ ...td, textAlign: 'right' }}>
                    {this.rowActionsFor(row.status, row).length > 0 &&
                      <IconButton size="small" onClick={(e) => this.openRowMenu(e, row)}><MoreVertIcon fontSize="small" /></IconButton>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </Box>
      </Box>
    );
  }

  renderSkeleton() {
    return (
      <Box sx={{ border: '1px solid #e0e0e0', borderRadius: '12px', p: 2, backgroundColor: '#fff' }}>
        {[...Array(5)].map((_, i) => (
          <Box key={i} sx={{ display: 'flex', alignItems: 'center', gap: 2, py: 1.2 }}>
            <Skeleton variant="rectangular" width={24} height={24} animation="wave" sx={{ borderRadius: 1 }} />
            <Skeleton variant="text" width="22%" animation="wave" />
            <Skeleton variant="text" width="14%" animation="wave" />
            <Skeleton variant="text" width="14%" animation="wave" />
            <Skeleton variant="text" width="12%" animation="wave" />
            <Skeleton variant="rounded" width={80} height={22} animation="wave" />
            <Skeleton variant="rounded" width={120} height={10} animation="wave" />
          </Box>
        ))}
      </Box>
    );
  }

  render() {
    const { classes, headerMenu, actionsHeaderMenu, intl } = this.props;
    const { loading, tab } = this.state;
    const rows = this.rowsForTab();
    const menuItems = this.state.rowMenuItem ? this.rowActionsFor(this.state.rowMenuItem.status, this.state.rowMenuItem) : [];

    return (
      <div className={classes.root} style={{ paddingLeft: 0, marginLeft: 0 }}>
        <HeaderMenu />
        <main className={clsx(classes.content, { [classes.contentShift]: headerMenu.open }, classes.actionsContent, { [classes.actionscontentShift]: actionsHeaderMenu.open })}>
          <div className={classes.drawerHeader} />
          <Container component='main' maxWidth='xl' style={{ maxWidth: '100%', paddingLeft: 0, marginLeft: 0 }}>
            <CssBaseline />

            {/* Cabeçalho da página */}
            <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', flexWrap: 'wrap', gap: 2, mb: 2 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                <Box sx={{ width: 44, height: 44, borderRadius: '10px', backgroundColor: '#eef7e3', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <CampaignOutlinedIcon sx={{ color: '#5b9b1e' }} />
                </Box>
                <Box>
                  <Typography sx={{ fontSize: 22, fontWeight: 700, color: '#333', lineHeight: 1.1 }}>{intl.formatMessage({ id: 'marketing.title' })}</Typography>
                  <Typography sx={{ fontSize: 13, color: '#888' }}>{intl.formatMessage({ id: 'marketing.subtitle' })}</Typography>
                </Box>
              </Box>
              <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                <Tooltip title={intl.formatMessage({ id: 'marketing.refresh' })}>
                  <span>
                    <IconButton onClick={this.refreshAll} disabled={loading}
                      sx={{ border: '1px solid #cfcfcf', borderRadius: '8px', color: '#8BC34A', width: 40, height: 40, '&:hover': { backgroundColor: '#f1f8e9', borderColor: '#8BC34A' } }}>
                      {loading ? <CircularProgress size={18} sx={{ color: '#8BC34A' }} /> : <RefreshIcon fontSize="small" />}
                    </IconButton>
                  </span>
                </Tooltip>
                <Button variant="outlined" startIcon={<ListAltOutlinedIcon />} onClick={this.goToLists}
                  sx={{ textTransform: 'none', borderColor: '#cfcfcf', color: '#444' }}>
                  {intl.formatMessage({ id: 'marketing.lists.title' })}
                </Button>
                <Button variant="contained" startIcon={<AddIcon />} onClick={this.goToNew}
                  sx={{ textTransform: 'none', backgroundColor: '#8BC34A', '&:hover': { backgroundColor: '#7cb342' } }}>
                  {intl.formatMessage({ id: 'marketing.new.broadcast' })}
                </Button>
              </Box>
            </Box>

            {/* Abas do ciclo de vida */}
            <Tabs value={tab} onChange={this.handleTabChange} sx={{ mb: 2, borderBottom: '1px solid #e8e8e8', '& .MuiTabs-indicator': { backgroundColor: '#8BC34A' } }}>
              {TAB_ORDER.map((status) => (
                <Tab key={status} sx={{ textTransform: 'none', fontWeight: 600, '&.Mui-selected': { color: '#5b9b1e' } }}
                  label={
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      {intl.formatMessage({ id: STATUS_META[status].tabKey })}
                      <Badge badgeContent={this.countByStatus(status)} color="default"
                        sx={{ '& .MuiBadge-badge': { backgroundColor: `${STATUS_META[status].badge} !important`, color: '#fff !important', fontWeight: 700, position: 'static', transform: 'none' } }} />
                    </Box>
                  } />
              ))}
            </Tabs>

            {/* Dica contextual da aba (textos do documento) */}
            <Typography sx={{ fontSize: 13, color: '#999', mb: 1.5, fontStyle: 'italic' }}>
              {intl.formatMessage({ id: `marketing.hint.${this.currentStatus()}` })}
            </Typography>

            {!loading && this.renderBulkBar()}
            {loading ? this.renderSkeleton() : (rows.length > 0 ? this.renderTable(rows) : this.renderEmpty())}

            {/* Paginação server-side por aba (10/25/50/100) */}
            {this.state.total > 0 && (
              <TablePagination component="div" count={this.state.total} page={this.state.page} rowsPerPage={this.state.rowsPerPage}
                rowsPerPageOptions={[10, 25, 50, 100]}
                onPageChange={(_e, p) => this.changePage(p)}
                onRowsPerPageChange={(e) => this.changeRowsPerPage(parseInt(e.target.value, 10))}
                labelRowsPerPage={intl.formatMessage({ id: 'marketing.list.preview.perPage' })}
                labelDisplayedRows={({ from, to, count }) => `${from}-${to} / ${count}`} />
            )}

            <Menu anchorEl={this.state.rowMenuAnchor} open={Boolean(this.state.rowMenuAnchor)} onClose={this.closeRowMenu}>
              {menuItems.map(a => (
                <MenuItem key={a.id} onClick={() => this.handleRowAction(a.id)} sx={{ fontSize: 13, gap: 1 }}>
                  {a.icon} {a.label}
                </MenuItem>
              ))}
            </Menu>
          </Container>
          <Footer />
        </main>
        {this.state.confirm && (
          <DialogConfirmation
            msg={intl.formatMessage({ id: 'marketing.confirm.title' })}
            optionToDelete={<span style={{ fontSize: '0.95rem', fontWeight: 400, color: '#444' }}>{this.state.confirm.msg}</span>}
            msgAgree={intl.formatMessage({ id: 'yes' })}
            msgDisagree={intl.formatMessage({ id: 'no' })}
            handleClose={() => this.setState({ confirm: null })}
            handleConfirmation={this.runConfirm}
          />
        )}
        {this.state.actionLoading && (
          <Overlay>
            <CircularProgress color="primary" />
          </Overlay>
        )}
        <CustomizedSnackbars variant={this.state.notification.variant} message={this.state.notification.message} isOpen={this.state.notification.open}
          toClose={() => this.setState({ notification: { ...this.state.notification, open: false } })} />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  headerMenu: state.headerMenu,
  actionsHeaderMenu: state.actionsHeaderMenu,
  userSession: state.userSession,
});
const mapDispatchToProps = dispatch => bindActionCreators(componentActions, dispatch);

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(MarketingBroadcastList)));
